// src/lib/managerReview.js
// STATUS: active | UPDATED: 2026-09-19
// LOG:
//   2026-09-19  New. Jazz settling his own manager system, one line at a time.
//
// See supabase/migrations/0034 for why the text is frozen into the row rather
// than read from the content file.

import { supabase } from './supabase'

export const SECTIONS = [
  { key: 'daily_disciplines', title: 'The daily disciplines', note: 'The shape of a day on your floor.' },
  { key: 'daily_audit', title: 'The daily audit', note: 'What a manager ticks off before the day is done.' },
  { key: 'weekly_rhythm', title: 'Every week', note: 'The coaching that does not happen unless it is scheduled.' },
  { key: 'one_on_one', title: 'The one on one', note: 'How you have it run, including the language.' },
  { key: 'scorecard', title: 'The scorecard', note: 'Six categories. Units and gross sit inside Results.' },
]

const COLS = 'id, section, position, source_text, status, corrected_text, decided_at'

export async function listReview() {
  const { data, error } = await supabase
    .from('manager_review')
    .select(COLS)
    .order('section')
    .order('position')
  return { data: data || [], error }
}

// confirmed  he runs it that way
// corrected  he runs it differently, and corrected_text is HIS wording
// dropped    he does not do this at all any more
//
// A correction clears nothing and replaces nothing in source_text. The row keeps
// what he was shown AND what he said, because the gap between them is the most
// interesting thing in this table.
export async function decide({ id, status, correctedText, userId }) {
  if (!['confirmed', 'corrected', 'dropped', 'pending'].includes(status)) {
    return { data: null, error: 'Unknown decision.' }
  }
  const text = String(correctedText || '').trim()
  if (status === 'corrected' && text.length === 0) {
    return { data: null, error: 'A correction needs your wording.' }
  }

  const patch = {
    status,
    corrected_text: status === 'corrected' ? text.slice(0, 2000) : null,
    decided_at: status === 'pending' ? null : new Date().toISOString(),
    decided_by: status === 'pending' ? null : userId || null,
    updated_at: new Date().toISOString(),
  }
  const { data, error } = await supabase
    .from('manager_review')
    .update(patch)
    .eq('id', id)
    .select(COLS)
    .single()
  return { data, error }
}
